import axiosInstance from "../axios/axios-configuration"
import { CancelToken } from "axios";
import { IFile } from "../shared/interfaces";
const controller = 'Files';

const convertToPdf = (file: IFile, cancelToken?: CancelToken): Promise<string> => {
    return axiosInstance.post(`${controller}/ConvertToPdf`,file, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const test = ( cancelToken?: CancelToken): Promise<string> => {
    return axiosInstance.get(`${controller}/Test`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}



export default {
    convertToPdf,
    test
}